import { AppPermissions } from 'constants/permissions';

export const permissions = {
  createProject: [AppPermissions.add_projects, AppPermissions.add_quotes, AppPermissions.add_shipment],
};
